import { useState } from 'react';
import { PERSONALIZED_INVITE_BY_CONDOMINIUM } from '../../settings';
import { buildClaudeRequest } from '../utils/buildClaudeRequest';
import { buildSettingsSnippet } from '../utils/buildSettingsSnippet';
import {
  getFileExtension,
  validateGeneratorForm,
} from '../utils/validateGeneratorForm';
import useObjectUrl from './useObjectUrl';

const EXISTING_PERSON_CONTEXT_IDS = Object.keys(
  PERSONALIZED_INVITE_BY_CONDOMINIUM,
).map(Number);

const INITIAL_VALUES = {
  clientName: '',
  personContextId: '',
  primaryColor: '',
  secondaryColor: '',
  logoFile: null,
  bannerFile: null,
  bannerFocus: 0,
  hostMessage: '',
  condominiumNotice: '',
};

const useGeneratorForm = () => {
  const [values, setValues] = useState(INITIAL_VALUES);
  const [errors, setErrors] = useState({});
  const [snippet, setSnippet] = useState(null);

  const logoUrl = useObjectUrl(values.logoFile);
  const bannerUrl = useObjectUrl(values.bannerFile);

  const handleFieldChange = (name, value) => {
    setValues(previous => ({ ...previous, [name]: value }));
    setSnippet(null);
  };

  const handleGenerate = () => {
    const formErrors = validateGeneratorForm(
      values,
      EXISTING_PERSON_CONTEXT_IDS,
    );
    setErrors(formErrors);

    if (Object.keys(formErrors).length) {
      setSnippet(null);
      return;
    }

    const personContextId = Number(values.personContextId.trim());
    const settingsSnippet = buildSettingsSnippet({
      clientName: values.clientName,
      personContextId,
      primaryColor: values.primaryColor,
      secondaryColor: values.secondaryColor,
      logoExtension: getFileExtension(values.logoFile),
      bannerExtension: getFileExtension(values.bannerFile),
      bannerFocus: values.bannerFocus,
      hostMessage: values.hostMessage,
      condominiumNotice: values.condominiumNotice,
    });

    setSnippet({
      ...settingsSnippet,
      claudeRequest: buildClaudeRequest({
        snippet: settingsSnippet,
        clientName: values.clientName,
        personContextId,
      }),
    });
  };

  return {
    values,
    errors,
    snippet,
    logoUrl,
    bannerUrl,
    handleFieldChange,
    handleGenerate,
  };
};

export default useGeneratorForm;
